import React, { useEffect, useState } from "react";
import {
  Table,
  Spin,
  Space,
  Upload,
  Input,
  Modal,
  Button,
} from "antd";
import { serverRequest } from "../../util/server_request";
import { useNavigate } from "react-router-dom";
import {
  SearchOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import {
  currencyFormatter,
  exportToCSV,
  exportToPDF,
  notifyUser,
} from "../../util/util";
import { PopupModal } from "../../components/PopupModal";
import { useValidationReportPDF } from '../../templates/ValidationReportTemplatePDF';

const { Dragger } = Upload;

const ScheduleUploadTable = (props) => {
	const downloadValidationReport = useValidationReportPDF();
  const navigate = useNavigate();
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [originalData, setOriginalData] = useState([]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const [uploadSuccessModal, setUploadSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [pinModal, setPinModal] = useState(false);
  const [pin, setPin] = useState("");
  const [uploadModal, setUploadModal] = useState(false);
  const [listSchedules, setListSchedules] = useState([]);
  const [listTotals, setListTotals] = useState({});
  const [scheduleMonth, setScheduleMonth] = useState("");
  const [scheduleSentState, setScheduleSentState] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);

  useEffect(() => {
    const fetchScheduleUploads = () => {
      toggleLoading();
      serverRequest("GET", "schedule/upload/months")
        .then((result) => {
          if (result) {
            toggleLoading();
            setUploads(result.data);
            setOriginalData(result.data);
          }
        })
        .catch((error) => {
          notifyUser("error", error.message, "Data fetching failed");
          toggleLoading();
        });
    };

    fetchScheduleUploads();
  }, []);

  const columns = [
    {
      title: "Month",
      dataIndex: "month",
      key: "month",
      onFilter: (value, record) => record.createdBy.includes(value),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      onFilter: (value, record) => record.createdBy.includes(value),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <button
          onClick={() =>
            navigate(`/dashboard/schedule/upload?month=${record.month}`)
          }
          className="btn btn-link text-decoration-none text-success p-0"
          style={{ cursor: "pointer" }}
        >
          View
        </button>
      ),
    },
  ];

  // Helper function to calculate expected 5% for salaries above 61k
  const calculateExpectedFivePer = (salary) => {
    if (salary >= 61000) {
      return (0.05 * salary) + (0.135 * (salary - 61000));
    }
    return salary * 0.05;
  };

  // Updated display function for preview table
  const formatPercentageForDisplay = (value) => {
    if (!value || 
        value.toString().trim() === "" || 
        value.toString().trim() === "-" || 
        value.toString().trim() === "-  " ||
        value.toString().trim() === "--" ||
        value.toString().trim() === "- " ||
        value.toString().trim() === " -" ||
        value.toString().trim() === "0" ||
        value.toString().trim() === "0.00" ||
        parseFloat(value.toString().replace(/[^\d.-]/g, '')) === 0) {
      return ""; // Display as empty for preview
    }
    return currencyFormatter(parseFloat(value.toString().replace(/[^\d.-]/g, '')));
  };

  const scheduleListColumns = [
    { title: "FIRST NAME", dataIndex: "FIRST NAME", key: "FIRST NAME" },
    { title: "LAST NAME", dataIndex: "LAST NAME", key: "LAST NAME" },
    { title: "OTHER NAME", dataIndex: "OTHER NAME", key: "OTHER NAME" },
    { 
      title: "SALARY", 
      dataIndex: "SALARY", 
      key: "SALARY",
      render: (value) => value ? currencyFormatter(parseFinancialNumber(value)) : ""
    },
    { title: "SSNIT NUMBER", dataIndex: "SSNIT NUMBER", key: "SSNIT NUMBER" },
    { title: "STAFF NUMBER", dataIndex: "STAFF NUMBER", key: "STAFF NUMBER" },
    { 
      title: "5%", 
      dataIndex: "5%", 
      key: "FIVE PER",
      render: (value) => formatPercentageForDisplay(value)
    },
    { 
      title: "18.50%", 
      dataIndex: "18.50%", 
      key: "EIGHTEEN PER",
      render: (value) => formatPercentageForDisplay(value)
    },
    { title: "GHANA CARD", dataIndex: "GHANA CARD", key: "GHANA CARD" },
  ];

  const toggleLoading = () => setLoading((prevState) => !prevState);
  const toggleUpload = () => setUploadModal((prevState) => !prevState);
  // const togglePinModal = () => setPinModal((prevState) => !prevState);
  // const toggleErrorModal = () => setErrorModal((prevState) => !prevState);
  const toggleScheduleSent = () =>
    setScheduleSentState((prevState) => !prevState);

  const closeUploadSuccessModal = () => {
    setUploadSuccessModal(false);
    setApiResponse(null);
  };

  // const closeAllModals = () => {
  //   setIsModalVisible(false);
  //   setUploadSuccessModal(false);
  //   setPinModal(false);
  //   setUploadModal(false);
  //   setErrorModal(false);
  //   setApiResponse(null);
  // };

  const fetchScheduleUploads = () => {
    toggleLoading();
    serverRequest("GET", "schedule/upload/months")
      .then((result) => {
        if (result) {
          toggleLoading();
          setUploads(result.data);
          setOriginalData(result.data);
        }
      })
      .catch((error) => {
        notifyUser("error", error.message, "Data fetching failed");
        toggleLoading();
      });
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filteredData = originalData.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(value))
    );
    setUploads(filteredData);
  };

  const downloadSample = () => {
    const link = document.createElement("a");
    link.href = "/SCHEDULE SAMPLE.xlsx";
    link.download = "SCHEDULE SAMPLE.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isEmptyRow = (row) => 
    Object.values(row).every(val => !val?.toString().trim());

  const isSummaryRow = (row) => {
    const firstName = row["FIRST NAME"]?.toString().trim().toLowerCase();
    const lastName = row["LAST NAME"]?.toString().trim().toLowerCase();
    return (
      firstName === "total" || 
      firstName === "amount due" ||
      firstName.includes("total") ||
      firstName.includes("amount due") ||
      lastName === "total" ||
      lastName === "amount due"
    );
  };

  const parseNumber = (value) => {
    if (!value) return NaN;
    return parseFloat(value.toString().replace(/[^\d.-]/g, ''));
  };

  // Updated helper functions for better handling of 5% and 18.50% columns
  const parsePercentage = (value) => {
    if (!value || 
        value.toString().trim() === "" || 
        value.toString().trim() === "-" || 
        value.toString().trim() === "-  " ||
        value.toString().trim() === "--" ||
        value.toString().trim() === "- " ||
        value.toString().trim() === " -" ||
        value.toString().trim() === "0" ||
        value.toString().trim() === "0.00" ||
        parseFloat(value.toString().replace(/[^\d.-]/g, '')) === 0) {
      return null; // Return null for empty, dash variations, or zero values
    }
    return parseFloat(value.toString().replace(/[^\d.-]/g, ''));
  };

  const parseFinancialNumber = (value) => {
    if (!value || 
        value.toString().trim() === "" || 
        value.toString().trim() === "-" || 
        value.toString().trim() === "-  " ||
        value.toString().trim() === "--" ||
        value.toString().trim() === "- " ||
        value.toString().trim() === " -" ||
        value.toString().trim() === "0" ||
        value.toString().trim() === "0.00") {
      return ""; // Return empty string for empty, dash variations, or zero values
    }
    return parseFloat(value.toString().replace(/,/g, '')) || "";
  };

  // Additional helper for submission data - returns empty string instead of 0
  // eslint-disable-next-line no-unused-vars
  const parsePercentageForSubmission = (value) => {
    if (!value || 
        value.toString().trim() === "" || 
        value.toString().trim() === "-" || 
        value.toString().trim() === "-  " ||
        value.toString().trim() === "0" ||
        parseFloat(value.toString().replace(/[^\d.-]/g, '')) === 0) {
      return ""; // Return empty string for submission when empty, dash, or zero
    }
    return parseFloat(value.toString().replace(/[^\d.-]/g, ''));
  };

  // Helper function to convert Excel percentage values to actual amounts
  const convertExcelPercentageToAmount = (value, salary) => {
    if (!value || !salary || isNaN(salary)) return value;
    
    const stringValue = value.toString().trim();
    
    // Handle empty or dash values (various dash formats)
    if (stringValue === "" || 
        stringValue === "-" || 
        stringValue === "-  " ||
        stringValue === "--" ||
        stringValue === "- " ||
        stringValue === " -" ||
        stringValue === "0" ||
        stringValue === "0.00") {
      return "";
    }
    
    // Handle percentage text like "5%" or "18.5%" - convert to decimal equivalent amount
    if (stringValue.includes('%')) {
      const percentageNum = parseFloat(stringValue.replace('%', ''));
      if (!isNaN(percentageNum)) {
        return salary * (percentageNum / 100);
      }
    }
    
    // Handle decimal values from Excel (e.g., 0.05 for 5%, 0.185 for 18.5%)
    const numValue = parseFloat(stringValue);
    if (!isNaN(numValue)) {
      // If the value is less than 1, assume it's a decimal percentage (e.g., 0.05 = 5%)
      if (numValue < 1 && numValue > 0) {
        return salary * numValue;
      }
      // If the value is greater than 1, assume it's already an amount
      return numValue;
    }
    
    return value;
  };

  const validateExcelFile = (data) => {
    const errors = [];
    const ssnitNumbers = new Set();
    
    const requiredColumns = ["FIRST NAME", "LAST NAME", "SSNIT NUMBER", "SALARY", "GHANA CARD"];
    const missingColumns = requiredColumns.filter(col => !data[0]?.[col]);
    if (missingColumns.length > 0) {
      notifyUser("error", `Missing required columns: ${missingColumns.join(", ")}`, "File Validation Failed");
      return { isValid: false, errors };
    }

    data.forEach((row, index) => {
      const rowNumber = index + 2;
      
      if (isEmptyRow(row)) return;
      if (isSummaryRow(row)) return;

      const missingFields = [];
      if (!row["FIRST NAME"]?.toString().trim()) missingFields.push("First Name");
      if (!row["LAST NAME"]?.toString().trim()) missingFields.push("Last Name");
      if (!row["SSNIT NUMBER"]?.toString().trim()) missingFields.push("SSNIT Number");
      if (!row["GHANA CARD"]?.toString().trim()) missingFields.push("Ghana Card");
      
      if (missingFields.length > 0) {
        errors.push(`Row ${rowNumber}: Missing required fields - ${missingFields.join(", ")}`);
        return;
      }
      
      // Validate Ghana Card format
      const ghanaCard = row["GHANA CARD"].toString().trim();
      if (!/^GHA-\d{9}-\d$/.test(ghanaCard)) {
        errors.push(`Row ${rowNumber}: Ghana Card must be in format GHA-xxxxxxxxx-x`);
      }
      
      const ssnit = row["SSNIT NUMBER"].toString().trim();
      if (ssnitNumbers.has(ssnit)) {
        errors.push(`Row ${rowNumber}: Duplicate SSNIT Number (${ssnit})`);
      } else {
        ssnitNumbers.add(ssnit);
      }
      
      const salary = parseNumber(row["SALARY"]);
      if (isNaN(salary)) {
        errors.push(`Row ${rowNumber}: SALARY must be a valid number`);
        return;
      }

      const fivePercent = parsePercentage(row["5%"]);
      const eighteenPercent = parsePercentage(row["18.50%"]);

      // Updated validation logic for different salary ranges
      if (salary >= 61000) {
        // For salaries 61k and above, validate 5% using the new formula
        const expectedFivePer = calculateExpectedFivePer(salary);
        
        if (fivePercent !== null && Math.abs(fivePercent - expectedFivePer) > 1) {
          errors.push(`Row ${rowNumber}: For salaries ≥61,000, 5% should be GH₵${expectedFivePer.toFixed(2)} (found GH₵${fivePercent.toFixed(2)})`);
        }
        
        // For salaries above 61k, 18.50% should not be provided or should be empty
        if (eighteenPercent !== null) {
          errors.push(`Row ${rowNumber}: For salaries ≥61,000, 18.50% should be empty or not provided`);
        }
      } else {
        // For salaries below 61k, ensure both 5% and 18.50% cannot be filled simultaneously
        if (fivePercent !== null && eighteenPercent !== null) {
          errors.push(`Row ${rowNumber}: You cannot have both 5% and 18.50% filled at the same time. Please provide only one.`);
          return;
        }
        
        // For salaries below 61k, at least one percentage should be provided
        if (fivePercent === null && eighteenPercent === null) {
          errors.push(`Row ${rowNumber}: For salaries below 61,000, either 5% or 18.50% must be provided`);
        }
        
        // Validate percentage calculations for salaries below 61k
        if (fivePercent !== null && Math.abs(fivePercent - salary * 0.05) > 1) {
          errors.push(`Row ${rowNumber}: 5% should be GH₵${(salary * 0.05).toFixed(2)} (found GH₵${fivePercent.toFixed(2)})`);
        }
        
        if (eighteenPercent !== null && Math.abs(eighteenPercent - salary * 0.185) > 1) {
          errors.push(`Row ${rowNumber}: 18.50% should be GH₵${(salary * 0.185).toFixed(2)} (found GH₵${eighteenPercent.toFixed(2)})`);
        }
      }
    });
    
    if (errors.length > 0) {
      const errorMessage = (
        <div>
          <p><strong>Your schedule upload contains {errors.length} validation error{errors.length > 1 ? 's' : ''} that must be fixed:</strong></p>
          <ul style={{ maxHeight: '300px', overflowY: 'auto', textAlign: 'left' }}>
            {errors.map((error, i) => (
              <li key={i} style={{ marginBottom: '8px' }}>{error}</li>
            ))}
          </ul>
          <div style={{ marginTop: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
            <strong>What to do next:</strong>
            <ul style={{ marginTop: '5px', marginBottom: '0' }}>
              <li>Fix the errors in your Excel file</li>
              <li>Make sure you don't have both 5% and 18.50% filled for the same person</li>
              <li>Ensure all required fields are properly filled</li>
              <li>Upload the corrected file again</li>
            </ul>
          </div>
        </div>
      );
      
      notifyUser("error", errorMessage, "File Validation Failed");
    }
    
    return { isValid: errors.length === 0, errors };
  };

  const handleUpload = (file) => {
    const isExcel =
      file.type === "application/vnd.ms-excel" ||
      file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    if (!isExcel) {
      notifyUser(
        "error",
        "You can only upload Excel files (.xls or .xlsx)!",
        "Error"
      );
      return false;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        let json = XLSX.utils.sheet_to_json(sheet);
        
        json = json.filter(row => 
          !(row["FIRST NAME"] === undefined && 
            row["LAST NAME"] === undefined && 
            row["SSNIT NUMBER"] === undefined)
        );

        // Process data to handle Excel percentage formatting and auto-calculate FIVE PER for salaries 61k and above
        const processedJson = json.map(row => {
          if (isEmptyRow(row) || isSummaryRow(row)) {
            return row;
          }

          // Handle Excel percentage formatting for 5% and 18.50% columns
          // Excel may store percentages as decimals (0.05 for 5%) or text ("5%")
          if (row["5%"]) {
            row["5%"] = convertExcelPercentageToAmount(row["5%"], parseNumber(row["SALARY"]));
          }
          
          if (row["18.50%"]) {
            row["18.50%"] = convertExcelPercentageToAmount(row["18.50%"], parseNumber(row["SALARY"]));
          }

          const salary = parseNumber(row["SALARY"]);
          if (!isNaN(salary) && salary >= 61000) {
            // Auto-calculate 5% for salaries 61k and above
            const calculatedFivePer = calculateExpectedFivePer(salary);
            row["5%"] = calculatedFivePer;
            // Clear 18.50% for salaries above 61k
            row["18.50%"] = "";
          }

          return row;
        });

        const validationResult = validateExcelFile(processedJson);
        
        if (!validationResult.isValid) {
          return;
        }

        setListSchedules(processedJson);
        setIsModalVisible(true);
        toggleUpload();
        const totals = calculateTotals(processedJson);
        setListTotals({
          totalContributions: totals.totalFivePer + totals.totalEighteenPer,
          totalFivePer: totals.totalFivePer,
          totalEighteenPer: totals.totalEighteenPer,
          totalSalary: totals.totalSalary,
        });
      } catch (error) {
        notifyUser("error", "Failed to process the Excel file. Please ensure it's properly formatted.", "Error");
        console.error("Error processing file:", error);
      }
    };
    
    reader.onerror = () => {
      notifyUser("error", "Failed to read the file. Please try again.", "Error");
    };
    
    reader.readAsArrayBuffer(file);
    return false;
  };

  // Updated calculateTotals function to handle empty strings
  const calculateTotals = (data) => {
    return data.reduce(
      (acc, row) => {
        if (isSummaryRow(row) || isEmptyRow(row)) {
          return acc;
        }

        const salary = parseFinancialNumber(row["SALARY"]);
        const fivePer = parseFinancialNumber(row["5%"]);
        const eighteenPer = parseFinancialNumber(row["18.50%"]);

        // Convert empty strings to 0 for calculation
        const salaryNum = salary === "" ? 0 : salary;
        const fivePerNum = fivePer === "" ? 0 : fivePer;
        const eighteenPerNum = eighteenPer === "" ? 0 : eighteenPer;

        return {
          totalFivePer: acc.totalFivePer + fivePerNum,
          totalEighteenPer: acc.totalEighteenPer + eighteenPerNum,
          totalSalary: acc.totalSalary + salaryNum
        };
      },
      { totalFivePer: 0, totalEighteenPer: 0, totalSalary: 0 }
    );
  };

 const verifyPinAndDownload = () => {
    downloadValidationReport(apiResponse);
    setPinModal(false);
  };

  const exportFunction = (type) => {
    if (type === "pdf") {
      exportToPDF(columns, uploads, "Schedule Uploads");
    } else {
      exportToCSV(uploads, "Schedule Uploads");
    }
  };

 // Updated member mapping for submission
 const submitUpload = () => {
  if (scheduleMonth === "" || scheduleMonth == null) {
    return notifyUser(
      "error",
      "Please select schedule date to proceed!",
      "Validation"
    );
  }
  
  toggleScheduleSent();
  const fundPeriod = scheduleMonth.split("-");
  
  const validMembers = listSchedules.filter(row => 
    !isEmptyRow(row) && !isSummaryRow(row)
  );
  
  // Helper to safely get trimmed string or empty string
  const safe = (v) => (v === undefined || v === null ? "" : String(v).trim());
  
  // Convert input to number or null
  const toBigDecimalOrNull = (value) => {
    if (!value || value.toString().trim() === "" || value.toString().trim() === "-") {
      return null;
    }
    const num = parseFloat(value.toString().replace(/[^\d.-]/g, ''));
    return isNaN(num) ? null : num;
  };
  
  const _members = validMembers.map((item) => ({
    firstName: safe(item["FIRST NAME"]),
    lastName: safe(item["LAST NAME"]),
    otherName: safe(item["OTHER NAME"]),
    ssnitNumber: safe(item["SSNIT NUMBER"]),
    salary: toBigDecimalOrNull(item["SALARY"]),
    postTaxEmployerAmount: null,
    preTaxEmployerAmount: null,
    staffNumber: safe(item["STAFF NUMBER"]),
    ghanaCardNumber: safe(item["GHANA CARD"]),
    fivePercent: toBigDecimalOrNull(item["5%"]),
    eighteenPercent: toBigDecimalOrNull(item["18.50%"]),
  }));
  
  let payload = {
    fundYear: fundPeriod[0],
    fundMonth: fundPeriod[1],
    members: _members,
  };
  
  serverRequest("POST", "schedule/upload", payload)
    .then((result) => {
      const combinedResponse = {
        ...result,
        requestData: {
          fundYear: parseInt(payload.fundYear, 10),
          fundMonth: parseInt(payload.fundMonth, 10),
          members: payload.members.map(m => ({
            firstName: m.firstName ?? "",
            lastName: m.lastName ?? "",
            salary: m.salary ?? "",
            fivePercent: m.fivePercent ?? "",
            eighteenPercent: m.eighteenPercent ?? "",
            ssnitNumber: m.ssnitNumber ?? "",
            staffNumber: m.staffNumber ?? "",
            ghanaNumber: m.ghanaNumber ?? ""
          })),
          totalFivePercent: payload.members.reduce((sum, m) => sum + (m.fivePercent || 0), 0),
          totalEighteenPercent: payload.members.reduce((sum, m) => sum + (m.eighteenPercent || 0), 0),
          totalSalary: payload.members.reduce((sum, m) => sum + (m.salary || 0), 0)
        }
      };
      
      setApiResponse(combinedResponse);
      toggleScheduleSent();
      
      if (!result?.success) {
        notifyUser("error", result?.message, "Error");
        return;
      }
      
      const hasErrors = result?.data?.errors && Array.isArray(result.data.errors) && result.data.errors.length > 0;
      
      if (hasErrors) {
        setIsModalVisible(false);
        setErrorModal(true);
        toggleUpload();
      } else {
        notifyUser("success", "Data uploaded successfully!", "Schedule Upload");
        setIsModalVisible(false);
        setUploadSuccessModal(true);
        toggleUpload();
      }
    })
    .catch(error => {
      toggleScheduleSent();
      notifyUser("error", error.message, "Upload Failed");
    });
}; 
  return (
    <div style={{ padding: "20px" }}>
      <div className="row mb-4">
        <div className="col">
          <p className="lead">Your Pension Contributions</p>
        </div>
        <div className="col"></div>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
          <div className="shadow p-4 rounded">
            <p className="lead mb-1">{uploads?.length}</p>
            <small>Total Uploads</small>
            <div className="mt-2">
              <span>
                <span className="badge bg-success fw-bold">
                  <i className="bi bi-cloud-upload" />
                </span>
              </span>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
          <div className="shadow p-4 rounded">
            <p className="lead mb-1">
              {uploads?.filter((item) => item.status !== "UPLOADED")?.length}
            </p>
            <small>Failed Uploads</small>
            <div className="mt-2">
              <span>
                <span
                  className="badge fw-bold"
                  style={{ backgroundColor: "#ffe5e5", color: "#FF0000" }}
                >
                  <i className="bi bi-graph-down-arrow" />
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <Space
          style={{
            marginBottom: 16,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <p className="lead">Schedule Uploads</p>
          <Space>
            <button className="btn btn-primary" onClick={toggleUpload}>
              Upload <i className="bi bi-cloud-upload" />
            </button>
            <div className="dropdown">
              <Button
                icon={<DownloadOutlined />}
                className="dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                EXPORT
              </Button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => exportFunction("csv")}
                  >
                    Export to CSV
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => exportFunction("pdf")}
                  >
                    Export to PDF
                  </button>
                </li>
              </ul>
            </div>
            <Input
              prefix={<SearchOutlined />}
              placeholder="SEARCH"
              style={{ width: 200 }}
              value={searchText}
              onChange={handleSearch}
              allowClear
            />
          </Space>
        </Space>
        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={uploads}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
          />
        </Spin>
      </div>

      {/* Upload Modal */}
      <Modal
        visible={uploadModal}
        onCancel={toggleUpload}
        footer={null}
        width={650}
      >
        <div className="p-4">
          <h2 className="fw-bold">Upload Schedule</h2>
          <p className="font-weight-light mb-2">
            Upload the pension schedule, firstly download the sample file below.
          </p>
          <p
            className="font-weight-light mb-5 text-success fw-bold"
            style={{ cursor: "pointer" }}
            onClick={downloadSample}
          >
            Download Sample.xslx
          </p>
          <Dragger
            beforeUpload={handleUpload}
            accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            maxCount={1}
            showUploadList={false}
          >
            <p className="ant-upload-drag-icon">
              <i className="bi bi-cloud-upload" />
            </p>
            <p className="ant-upload-text">Schedule Upload</p>
            <p className="ant-upload-hint">Max 10MB</p>
          </Dragger>
        </div>
      </Modal>

      {/* Schedule Summary Modal */}
      <Modal
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={1200}
      >
        <div className="p-3">
          <h2 className="fw-bold">Schedule Summary</h2>
          <p className="">See your schedule summary</p>

          <p className="fw-bold">
            Total Five Per: GH₵{currencyFormatter(listTotals?.totalFivePer)}
          </p>
          <p className="fw-bold">
            Total Eighteen Per: GH₵
            {currencyFormatter(listTotals?.totalEighteenPer)}
          </p>
          <p className="fw-bold">
            Total Salary : GH₵{currencyFormatter(listTotals?.totalSalary)}
          </p>
          <p className="fw-bold">
            Total Contributions : GH₵
            {currencyFormatter(listTotals?.totalContributions)}
          </p>

          <div className="">
            <Spin spinning={scheduleSentState}>
              <Table
                columns={scheduleListColumns}
                dataSource={listSchedules}
                bordered
                pagination={{ pageSize: 10 }}
              />
              <div className="row align-items-center mt-4">
               <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12">
                  <omk-date-picker
                    label="Select Schedule Date"
                    value={scheduleMonth}
                    type="date"
                    className="mb-4"
                    name="scheduleMonth"
                    onInput={(e) => setScheduleMonth(e.target.value)}
                  />
                </div>
                <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 text-end">
                  <button
                    className="btn btn-primary w-50 mobile-full-width"
                    onClick={submitUpload}
                    disabled={scheduleSentState}
                  >
                    {scheduleSentState ? 'Uploading...' : 'Submit'}
                  </button>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </Modal>

      {/* Success Modal */}
<PopupModal
  title="Schedule Uploaded Successfully!"
  subTitle={
    <div className="d-flex flex-column">
      <span>Your Upload has been made successfully</span>
      <div className="d-flex gap-3 mt-4">
        <button 
          className="btn btn-primary flex-grow-1" 
          onClick={() => {
            closeUploadSuccessModal();
            fetchScheduleUploads();
          }}
        >
          CONTINUE
        </button>
        <button 
          className="btn btn-primary flex-grow-1" 
          onClick={() => downloadValidationReport(apiResponse)}
        >
          Download Report
        </button>
      </div>
    </div>
  }
  isOpen={uploadSuccessModal}
  closeFn={() => {
    closeUploadSuccessModal();
    fetchScheduleUploads();
  }}
  closeText={null} // Hide the default button
/>
      {/* Error Modal */}
      <Modal 
        open={errorModal} 
        onCancel={() => setErrorModal(false)} 
        footer={null} 
        width={700}
      >
        <div className="p-4">
          <div className="text-center mb-4">
            <div className="mb-3">
              <span className="badge bg-danger p-3 rounded-circle">
               
                <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '2rem' }} />
              </span>
            </div>
            <h4 className="text-danger">Upload Contains Validation Errors</h4>
            <p className="text-muted">
              Your schedule was not uploaded it contains validation errors. Please add missing members or fix the errors below, then upload a corrected file.
            </p>
          </div>
          
          {apiResponse?.data?.errors && (
            <div className="mb-4">
              <h6>Error Details:</h6>
              <div 
                className="border rounded p-3" 
                style={{ maxHeight: '200px', overflowY: 'auto', backgroundColor: '#f8f9fa' }}
              >
                {apiResponse.data.errors.map((error, i) => (
                  <div key={i} className="mb-2">
                    <strong>Staff Number:</strong> {error.staffNumber}<br />
                    <span className="text-danger">{error.errorMessage}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          <div className="text-center mb-3">
            <div className="alert alert-warning" role="alert">
              <i className="bi bi-info-circle-fill me-2"></i>
              <strong>Action Required:</strong> Please fix the validation errors above and upload your file again. 
              The download report feature is only available for successfully uploaded schedules.
            </div>
          </div>
          
          <div className="d-flex justify-content-center gap-3">
            <button 
              className="btn btn-primary" 
              onClick={() => setErrorModal(false)}
            >
              Close & Fix Errors
            </button>
            {apiResponse?.data?.errors?.some(error => {
              const errorMsg = error.errorMessage?.toLowerCase() || '';
              return (
                // Check for member-related existence errors
                (errorMsg.includes('member') && (
                  errorMsg.includes('doesn\'t exist') ||
                  errorMsg.includes('does not exist') ||
                  errorMsg.includes('not found') ||
                  errorMsg.includes('not exist')
                )) ||
                // Check for staff number related errors that might indicate missing members
                (errorMsg.includes('staff') && (
                  errorMsg.includes('not found') ||
                  errorMsg.includes('does not exist') ||
                  errorMsg.includes('doesn\'t exist')
                )) ||
                // Check for SSNIT number related errors
                (errorMsg.includes('ssnit') && (
                  errorMsg.includes('not found') ||
                  errorMsg.includes('does not exist') ||
                  errorMsg.includes('doesn\'t exist')
                ))
              );
            }) && (
              <button 
                className="btn btn-primary" 
                onClick={() => {
                  setErrorModal(false);
                  navigate('/dashboard/members/new');
                }}
              >
                <i className="bi bi-person-plus me-2"></i>
                Create Members
              </button>
            )}
          </div>
        </div>
      </Modal>

      {/* PIN Modal */}
      <Modal 
        open={pinModal} 
        onCancel={() => setPinModal(false)} 
        footer={null} 
        width={600}
      >
        <div align={"center"}>
          <div className="p-4">
            <div className="mb-4">
              <h4>Enter PIN to download validation report</h4>
              <Input.Password
                value={pin}
                onChange={(e) => setPin(e.target.value)}
                style={{ width: 200 }}
                maxLength={4}
              />
            </div>
            <button 
              className="btn btn-primary" 
              onClick={verifyPinAndDownload}
              disabled={pin.length !== 4}
            >
              Confirm & Download
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ScheduleUploadTable;
